<template>
  <div style="width: 58px" class="ModuleList d-flex justify-center">
    <inno-icon :fontSize="`${size}px`" v-if="module.innoIcon" :icon-color="iconColor" :icon="module.innoIcon"></inno-icon>
    <v-icon v-else-if="module.icon" :size="size" class="pr-1" :color="iconColor">{{ module.icon }}</v-icon>
    <svg-icon v-else-if="module.svgIcon" :icon-color="iconColor" :svgIcon="module.svgIcon"></svg-icon>
    <img-icon
      :style="imgIconStyle"
      v-else

      :color="iconColor"
      :invertImgIcons="invertImgIcons"
      :icon="darkMode && module.imgIconDark ? module.imgIconDark : module.imgIcon"
    ></img-icon>
  </div>
</template>

<script>
import InnoIcon from '@/components/icons/InnoIcon';
import ImgIcon from '@/components/icons/ImgIcon';
import common from '@/mixins/common';
import SvgIcon from '@/components/icons/SvgIcon.vue';

export default {
  name: 'ModuleIcon',
  mixins: [common],
  components: {
    SvgIcon,
    InnoIcon,
    ImgIcon,
  },
  props: {
    invertImgIcons: { type: Boolean, default: false },
    module: Object,
    iconColor: String,

    size: {
      type: Number,
      default: 24,
    },
    iconHeight: Number, // if set, the imgIcon height will be set and the size used for height and width is ignored
    iconWidth: Number, // if set, the imgIcon width will be set and the size used for height and width is ignored
  },
  computed: {
    imgIconStyle() {
      if (this.iconHeight) {
        return { height: this.iconHeight + 'px' };
      } else if (this.iconWidth) {
        return { width: this.iconWidth + 'px' };
      }

      return `height:${this.size}px`;
      // return `width:${this.size}px;height:${this.size}px`;
    },
  },
};
</script>
